var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.endTimes)?_c('div',{staticClass:"Timer clearfix"},[_c('span',{staticClass:"timer_description"},[_vm._v(_vm._s(_vm.description))]),_c('span',{staticClass:"timer_data"},[_vm._v(_vm._s(_vm._f("timeFilter")(_vm.remainingTime)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }